import { XCircle } from "lucide-react";
import classNames from "./classNames";

export default function Modal({ open, title, onClose, children, max = "max-w-3xl" }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/40" onClick={onClose} />

      <div
        className={classNames(
          "relative w-full rounded-2xl border border-blue-100 bg-white shadow-xl max-h-[90vh] flex flex-col",
          max
        )}
      >
        {/* Header */}
        <div className="flex items-center justify-between gap-3 border-b border-blue-100 p-4">
          <p className="text-base font-semibold text-slate-900">{title}</p>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center rounded-xl border border-blue-100 bg-blue-50 p-2 text-blue-700 hover:bg-blue-100"
          >
            <XCircle className="h-4 w-4" />
          </button>
        </div>

        {/* Scrollable Body */}
        <div className="p-6 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
}



// import { XCircle } from "lucide-react";
// import classNames from "./classNames";

// export default function Modal({ open, title, onClose, children, max = "max-w-3xl" }) {
//   if (!open) return null;
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
//       <div className="absolute inset-0 bg-slate-900/40" onClick={onClose} />
//       <div className={classNames("relative w-full rounded-2xl border border-blue-100 bg-white shadow-xl", max)}>
//         <div className="flex items-center justify-between gap-3 border-b border-blue-100 p-4">
//           <p className="text-base font-semibold text-slate-900">{title}</p>
//           <button
//             type="button"
//             onClick={onClose}
//             className="inline-flex items-center justify-center rounded-xl border border-blue-100 bg-blue-50 p-2 text-blue-700 hover:bg-blue-100"
//           >
//             <XCircle className="h-4 w-4" />
//           </button>
//         </div>
//          <div className="p-6 overflow-y-auto">{children}</div>
//       </div>
//     </div>
//   );
// }